module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/7start#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/8chap1#chap1"
    }
  }, [_vm._v("1 When Is a Frenchman Not a Frenchman?"), _c('br'), _c('i', [_vm._v("1066: the Normans cross the Channel to kick the Anglo-Saxons into shape for a 1,000-year career of")]), _vm._v(" a"), _c('i', [_vm._v("nnoying the French.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9chap2#chap2"
    }
  }, [_vm._v("2 French-bashing in Its Infancy"), _c('br'), _c('i', [_vm._v("As performed by some great ")]), _vm._v("– "), _c('i', [_vm._v("and some frankly awful ")]), _vm._v("–"), _c('br'), _c('i', [_vm._v("Kings of England. ")]), _vm._v("("), _c('i', [_vm._v("Queens were still illegal.")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/10chap3#chap3"
    }
  }, [_vm._v("3 The Hundred Years War: A Huge Mistake"), _c('br'), _c('i', [_vm._v("The ‘hundred’ years from 1337 to 1453: more than just a mathematical error.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11chap4#chap4"
    }
  }, [_vm._v("4 Joan of Arc: A Martyr to French Propaganda"), _c('br'), _c('i', [_vm._v("The public roasting given to France’s patron saint,")]), _vm._v(" o"), _c('i', [_vm._v("r what really happened in 1431.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/12chap5#chap5"
    }
  }, [_vm._v("5 Calais: The Last Last Bit of English Territory in France"), _c('br'), _c('i', [_vm._v("The French town that was a British colony for 200 years, and the scene of Henry VII’s greatest fashion moment.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/13chap6#chap6"
    }
  }, [_vm._v("6 Mary Queen of Scots: A French Head on Scottish Shoulders"), _c('br'), _c('i', [_vm._v("When she was executed, no one was more annoyed")]), _vm._v(" t"), _c('i', [_vm._v("han the French. Apart from Mary herself, of course.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/14chap7#chap7"
    }
  }, [_vm._v("7 French Canada, or How to Lose a Colony"), _c('br'), _c('i', [_vm._v("French kings let the Brits steal the top half of a")]), _vm._v(" c"), _c('i', [_vm._v("ontinent.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/15chap8#chap8"
    }
  }, [_vm._v("8 Charles II: The Man Who Taught Everyone to Distrust French Motives for Doing Absolutely Anything"), _c('br'), _c('i', [_vm._v("The English fop who sought political asylum in Paris, betrayed his own country and then accidentally tricked the French into betraying themselves.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/16chap9#chap9"
    }
  }, [_vm._v("9 Champagne: Dom Pérignon Gets It Wrong"), _c('br'), _c('i', [_vm._v("Proof that the French didn’t invent their national drink.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/17chap10#chap10"
    }
  }, [_vm._v("10 Eclipsing the Sun King"), _c('br'), _c('i', [_vm._v("Louis XIV ")]), _vm._v("("), _c('i', [_vm._v("1638 -1715")]), _vm._v("), "), _c('i', [_vm._v("the French King with a")]), _vm._v(" g"), _c('i', [_vm._v("iant bladder and an ego to match.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/18chap11#chap11"
    }
  }, [_vm._v("11 Voltaire: A Frenchman Who Loved to Get France in the "), _c('i', [_vm._v("Merde")]), _c('br'), _c('i', [_vm._v("The eighteenth-century French thinker who thought more of Britain than of France.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/19chap12#chap12"
    }
  }, [_vm._v("12 Why Isn’t America Called L’Amérique?"), _c('br'), _c('i', [_vm._v("Which it might well have been, if the French hadn’t threatened to kill a British cow")]), _vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/20chap13#chap13"
    }
  }, [_vm._v("13 American Independence – from France"), _c('br'), _c('i', [_vm._v("1776: the Brits weren’t the only ones getting booted")]), _vm._v(" o"), _c('i', [_vm._v("ut of America.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/21chap14#chap14"
    }
  }, [_vm._v("14 India and Tahiti: France Gets Lost in Paradise"), _c('br'), _c('i', [_vm._v("A selection of historical Frenchmen lose India, fail to notice Australia and give sexually transmitted")]), _vm._v(" d"), _c('i', [_vm._v("iseases to Pacific islanders.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/22chap15#chap15"
    }
  }, [_vm._v("15 The Guillotine, a British Invention"), _c('br'), _c('i', [_vm._v("Another non-French idea.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/23chap16#chap16"
    }
  }, [_vm._v("16 The French Revolution: Let Them Eat Cake. Or Failing That, Each Other"), _c('br'), _c('i', [_vm._v("The tragi-comic truth about Bastille Day, Marie-Antoinette and the impoverished ")]), _vm._v("aristos.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/24chap17#chap17"
    }
  }, [_vm._v("17 Napoleon: If "), _c('i', [_vm._v("Je")]), _vm._v(" Ruled the World"), _c('br'), _c('i', [_vm._v("The rise of Bonaparte: soldier, emperor, lover of Josephine and creator of the French brothel.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/25chap18#chap18"
    }
  }, [_vm._v("18 Wellington Puts the Boot in on Boney"), _c('br'), _c('i', [_vm._v("Napoleon’s downfall at the hands ")]), _vm._v("("), _c('i', [_vm._v("and feet")]), _vm._v(") "), _c('i', [_vm._v("of the")]), _c('br'), _c('i', [_vm._v("Iron Duke.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/26chap19#chap19"
    }
  }, [_vm._v("19 Food, Victorious Food"), _c('br'), _c('i', [_vm._v("The baguette, the croissant and le steak: the real story")]), _vm._v(" b"), _c('i', [_vm._v("ehind three quintessentially ‘French’ foodstuffs.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/27chap20#chap20"
    }
  }, [_vm._v("20 The Romantics: The Brits Trash French Art "), _c('br'), _c('i', [_vm._v("How some hot-blooded Anglais stirred up French")]), _vm._v(" c"), _c('i', [_vm._v("ulture in the early 1800s.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/28chap21#chap21"
    }
  }, [_vm._v("21 How Britain Killed Off the Last French Royals"), _c('br'), _vm._v("…"), _c('i', [_vm._v("and the Victorians said, ‘It was an accident,")]), _vm._v(" h"), _c('i', [_vm._v("onest.’ Three times.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/29chap22#chap22"
    }
  }, [_vm._v("22 Why All French Wine Comes from America"), _c('br'), _c('i', [_vm._v("The grape disease heroically cured (and, less heroically, caused) by the Americans.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/30chap23#chap23"
    }
  }, [_vm._v("23 Edward VII Has a Frolicking Good Time in Paris "), _c('br'), _c('i', [_vm._v("‘Dirty Bertie’, the playboy prince who seduced France into signing the Entente Cordiale.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/31chap24#chap24"
    }
  }, [_vm._v("24 Britain and France Fight Side by Side for Once"), _c('br'), _c('i', [_vm._v("World War One, in which English-speaking soldiers took French leave, used French letters and sang")]), _vm._v(" r"), _c('i', [_vm._v("ude songs about the mesdemoiselles.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/32chap25#chap25"
    }
  }, [_vm._v("25 World War Two, Part One"), _c('br'), _c('i', [_vm._v("Don’t mention Dunkirk.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/33chap26#chap26"
    }
  }, [_vm._v("26 World War Two, Part Two"), _c('br'), _c('i', [_vm._v("Don’t mention collaboration or the number of French soldiers who actually landed on D-Day either.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/34chap27#chap27"
    }
  }, [_vm._v("27 Le Temps du Payback"), _c('br'), _c('i', [_vm._v("From de Gaulle to Thatcher, or Chanel handbags at ten paces.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/35chap28#chap28"
    }
  }, [_vm._v("28 Napoleon’s Dream Comes True"), _c('br'), _c('i', [_vm._v("The Channel Tunnel and some right royal gaffes that prove we’ve learned nothing from the past 1,000 years.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/36chap29#chap29"
    }
  }, [_vm._v("Quotations"), _c('br'), _c('i', [_vm._v("Mischievous things said by and about the French.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/37chap30#chap30"
    }
  }, [_vm._v("Select Bibliography"), _c('br'), _c('i', [_vm._v("Further reading in English and français.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/38chap31#chap31"
    }
  }, [_vm._v("Illustration Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/39chap32#chap32"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dc6ab8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6-TOC.vue
// module id = 78
// module chunks = 0